export const GOOGLE_SEO_TAG = 'jKteFe9v46zuYwxMBOI0rP5PB5Ope9td-Kj_SP1O280';
export const BING_SEO_TAG = 'B210BEFE44C3BC2CB0AEE1325BDC4DE0';
